import { render, staticRenderFns } from "./updateExam.vue?vue&type=template&id=0eaefb41&scoped=true&"
import script from "./updateExam.vue?vue&type=script&lang=js&"
export * from "./updateExam.vue?vue&type=script&lang=js&"
import style0 from "./updateExam.vue?vue&type=style&index=0&id=0eaefb41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaefb41",
  null
  
)

export default component.exports